import { atom } from 'jotai';

export const bulkTearsheetGenerationModalOpenState = atom<boolean>(false);
